import {ChangeDetectionStrategy, Component, inject, input, output} from "@angular/core";
import {bzIconTimeWindowOutline} from "@bringoz/ui/icons";
import {BringozDateRange} from "../../models/bringoz-date-range.model";
import {CommonsDialogService} from "../../../services/commons-dialog.service";
import {ILogService} from "angular";

@Component({
  selector: "app-bringoz-time-picker",
  templateUrl: "./bringoz-time-picker.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BringozTimePickerComponent {
  readonly isDisabled = input(false);
  readonly range = input<BringozDateRange>();
  readonly isShowTimeWindowTab = input(false);

  readonly timeSelect = output<BringozDateRange>();

  readonly icon = bzIconTimeWindowOutline;

  private readonly commonsDialogService = inject<CommonsDialogService>("commonsDialogService" as never);
  private readonly log = inject<ILogService>("$log" as never);

  openDialog(event: MouseEvent): void {
    const range = this.range();
    Promise.resolve(this.commonsDialogService.timeSelection(range, range?.dateStart, this.isShowTimeWindowTab(), event))
      .then((picked) => this.timeSelect.emit(picked))
      .catch((error: {message?: string} | undefined) => {
        if (error) {
          this.log.info(error.message);
        } else {
          this.log.info("Dialog Closed");
        }
      });
  }
}
